import AccountMarketingMaterialEventFlyerTemplate from './AccountMarketingMaterialEventFlyerTemplate';

export default AccountMarketingMaterialEventFlyerTemplate;
